import { useState, useEffect } from "react";

const LINKS = [
  { href: "#series", label: "色系分类" },
  { href: "#atlas", label: "色卡图鉴" },
  { href: "#compare", label: "跨系对照" },
  { href: "#scenes", label: "应用场景" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于图鉴" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-4 md:px-6 h-16 md:h-[72px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" aria-label="黑料色色卡图鉴首页">
          <span className="flex w-9 h-9 items-center justify-center rounded-md bg-primary-900 overflow-hidden">
            <span className="w-3.5 h-3.5 rounded-[2px] bg-background-50 shadow-[inset_-2px_-2px_0_rgba(184,142,77,0.6)]" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-foreground-950 font-serif text-base md:text-lg tracking-wide">黑料色</span>
            <span className="text-accent-600 text-[10px] tracking-display mt-1 uppercase font-medium">Color Atlas</span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-accent-500 after:transition-all hover:after:w-full"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#atlas"
            className="whitespace-nowrap rounded-md bg-primary-900 text-background-50 px-4 py-2 text-sm hover:bg-primary-800 transition-colors"
          >
            查看图鉴
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 flex items-center justify-center text-foreground-900 cursor-pointer"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-2xl`} />
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50/95 backdrop-blur-md px-4 py-3">
          <div className="flex flex-col">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-3 text-[15px] text-foreground-700 hover:text-foreground-950 border-b border-background-100 last:border-0"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#atlas"
              onClick={() => setOpen(false)}
              className="mt-3 whitespace-nowrap rounded-md bg-primary-900 text-background-50 px-4 py-2.5 text-center text-sm hover:bg-primary-800"
            >
              查看图鉴
            </a>
          </div>
        </div>
      )}
    </header>
  );
}